<template>
  <div class="tongji-wrapper w-100">
    <div class="top-wrapper flex-box">
      <div class="part mr-16 flex-1">
        <div class="count-wrapper">
          <div class="left flex-col">
            <span class="count">{{ countObj.countDay }}</span>
            <span class="subtitle">日访问量</span>
          </div>
          <div class="right">
            <img src="@images/website/icon_day@2x.png" alt="">
          </div>
        </div>
        <!-- <div class="chart-wrapper">
          <div v-if="countObj.countDay > 0" class="chart" ref="chart1"></div>
          <el-empty v-else description="暂无数据"></el-empty>
        </div> -->
      </div>

      <div class="part mr-16 flex-1">
        <div class="count-wrapper">
          <div class="left flex-col">
            <span class="count">{{ countObj.countWeek }}</span>
            <span class="subtitle">周访问量</span>
          </div>
          <div class="right">
            <img src="@images/website/icon_week@2x.png" alt="">
          </div>
        </div>
        <!-- <div class="chart-wrapper">
          <div v-if="countObj.countWeek > 0" class="chart" ref="chart2"></div>
          <el-empty v-else description="暂无数据"></el-empty>

        </div> -->
      </div>

      <div class="part mr-16 flex-1">
        <div class="count-wrapper">
          <div class="left flex-col">
            <span class="count">{{ countObj.countMonth }}</span>
            <span class="subtitle">月访问量</span>
          </div>
          <div class="right">
            <img src="@images/website/icon_month@2x.png" alt="">
          </div>
        </div>
        <!-- <div class="chart-wrapper">
          <div v-if="countObj.countMonth > 0" class="chart" ref="chart3"></div>
          <el-empty v-else description="暂无数据"></el-empty>

        </div> -->
      </div>

      <div class="part mr-16 flex-1">
        <div class="count-wrapper">
          <div class="left flex-col">
            <span class="count">{{ countObj.countYear }}</span>
            <span class="subtitle">年访问量</span>
          </div>
          <div class="right">
            <img src="@images/website/icon_year@2x.png" alt="">
          </div>
        </div>
        <!-- <div class="chart-wrapper">
          <div v-if="countObj.countYear > 0" class="chart" ref="chart4"></div>
          <el-empty v-else description="暂无数据"></el-empty>

        </div> -->
      </div>

      <div class="part flex-1">
        <div class="count-wrapper">
          <div class="left flex-col">
            <span class="count">{{ countObj.countTotal }}</span>
            <span class="subtitle">总访问量</span>
          </div>
          <div class="right">
            <img src="@images/website/icon_add@2x.png" alt="">
          </div>
        </div>
        <!-- <div class="chart-wrapper">
          <div v-if="countObj.countTotal > 0" class="chart" ref="chart5"></div>
          <el-empty v-else description="暂无数据"></el-empty>

        </div> -->
      </div>
    </div>

    <div class="middle-wrapper">
      <div class="search-box">
        <div class="left">
          <span class="mr-30">访问量</span>
          <span>{{ total }}</span>
        </div>
        <div class="right">
          <span class="time c-p" :class="{'active':item.value == searchType}" v-for="(item, index) in timeArr"
            @click="changeDate(item.value)" :key="index">{{ item.name }}</span>
          <el-date-picker v-model="value1" @change="selectDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            type="daterange" for start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>

      </div>

      <div class="chart-box">
        <div v-if="total > 0" class="chart" ref="chart6"></div>
        <el-empty v-else description="暂无数据"></el-empty>

      </div>
    </div>
    <!-- <img src="@images/website/pic_hb@2x.png" alt=""> -->
    <div class="province-wrapper">
      <div class="province-inner">
        <div class="province-part flex-col" v-for="(item, index) in provinceList" :key="index">
          <p class="p1">{{ item.value }}</p>
          <p class="p2">{{ item.name }}</p>
          <div v-if="item.picUrl" class="img-wrapper">
            <img :src="require('@images/website/'+item.picUrl)" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import provinceData from '@/libs/globalFunction/province-pics.json'
export default {

  data() {
    return {
      countObj: {},
      dateQuery: {
        startDate: '',
        endDate: ''
      },
      provinceData,
      total: '',
      searchType: 1,
      timeArr: [{ name: '今日', value: '1' }, { name: '本周', value: '2' }, { name: '本月', value: '3' }, { name: '全年', value: '4' },],
      value1: "",
      colorObj: {
        1: ['#32645B', '#AFD6CF'],
        2: ['#A98442', '#EAC481'],
        3: ['#588DA5', '#ADE3FC'],
        4: ['#7D3933', '#FBA6A0'],
        5: ['#7B55AE', '#B6AFD1']
      },
      provinceList: []
    };
  },

  async mounted() {
    this.countObj = await this.getCountSummary()
    this.countSearch(1)
    this.getCountProv()
    // this.countSearchByType(1)
    // this.countSearchByType(2)
    // this.countSearchByType(3)
    // this.countSearchByType(4)
    // this.countSearchByType(5)
  },

  methods: {
    getCountSummary() {
      return new Promise((resolve, reject) => {
        this.$http.get('/webadmin/countSummary', {
          ltype: '1'
        }).then(res => {
          if (res.success) {
            let results = res.result
            resolve(results)
          }
        })
      })
    },

    countSearchByType(type) {
      let param = {
        type: type,
        ltype: '1'
      }
      if (type == 5) {
        param.type = 0
        var currentYear = new Date().getFullYear();
        param.startDate = this.$common.formatDateString(new Date(`${currentYear - 20}-01-01`), 'yyyy-MM-dd')
        param.endDate = this.$common.formatDateString(new Date(), 'yyyy-MM-dd')
      }
      this.$http.get('/webadmin/countSearch', param).then(res => {
        if (res.success) {
          let results = res.result
          if (results.total > 0) {
            this.$nextTick(() => {
              let chart = this.$echarts.init(this.$refs[`chart${type}`])
              chart.showLoading();
              this.initLineChart(results, type, chart)
            });
          }
        }
      })
    },

    getCountProv() {
      this.$http.get('/webadmin/countProv', {
        ltype: '1'
      }).then(res => {
        if (res.success) {
          let results = res.result
          for (let i in this.provinceData) {
            results.map(item => {
              if (!item.picUrl) {
                this.$set(item, 'picUrl', 'default-img.png');
              }
              if (item.name.indexOf(i) != -1) {
                item.picUrl = this.provinceData[i]
              }
            })
          }
          let tempProvinceList = results.sort((a, b) => {
            return b.value - a.value
          })
          this.provinceList = tempProvinceList.slice(0, 5)
          console.log(this.provinceList)
        }
      })
    },

    changeDate(type) {
      this.searchType = type
      this.countSearch()
    },

    selectDate(val) {
      this.searchType = 0
      if (val) {
        this.dateQuery = {
          startDate: val[0],
          endDate: val[1],

        }
      }
      this.countSearch()
    },

    countSearch() {
      let param = {
        type: this.searchType,
        ltype: '1'
      }
      if (this.searchType == 0) {
        param.startDate = this.dateQuery.startDate
        param.endDate = this.dateQuery.endDate

      }
      this.$http.get('/webadmin/countSearch', param).then(res => {
        if (res.success) {
          let results = res.result
          this.total = results.total
          if (results.total > 0) {
            this.$nextTick(() => {
              let chart = this.$echarts.init(this.$refs.chart6)
              chart.showLoading();
              this.initVisitChart(results, chart)
            });
          }
        }
      })
    },

    initLineChart(obj, type, chart) {
      let opt = {
        grid: {
          left: '0%',   //距左边边框的距离
          right: '0%',  //距右边边框的距离
          bottom: '0',//距下面边框的距离
          top: '0',    //距上面边框的距离
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: false, //隐藏y轴
          },
          axisTick: {
            show: false,  //刻度线
          },
          axisLabel: {
            show: false, //隐藏刻度值
          },
          boundaryGap: false,
          data: obj.label
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false, //隐藏y轴
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,  //刻度线
          },
          axisLabel: {
            show: false, //隐藏刻度值
          },
        },

        series: [
          {
            data: obj.value,
            type: 'line',
            // symbol: "none",
            itemStyle: {
              normal: {
                color: this.colorObj[type][0],
              },
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: this.colorObj[type][0],
                    },
                    {
                      offset: 1,
                      color: this.colorObj[type][1],
                    },
                  ],
                  false
                ),
              },
            }
          }
        ]
      };

      chart.setOption(opt);
      chart.hideLoading()
      window.addEventListener("resize", function () {
        chart.resize();
      });
    },

    initVisitChart(obj, chart) {
      let opt = {
        title: {
          text: '访问量趋势'
        },
        grid: {
          left: '20',   //距左边边框的距离
          right: '0%',  //距右边边框的距离
          bottom: '24          ',//距下面边框的距离
          top: '60',    //距上面边框的距离
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,  //刻度线
          },
          axisLabel: {
            color: '#777777'
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#E6E6E6",
            }
          },
          data: obj.label
        },
        yAxis: {
          type: 'value',

          axisLine: {
            show: false, //隐藏y轴
          },

          axisLabel: {
            color: '#777777'
          },

          axisTick: {
            show: false,  //刻度线
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: '#2C9673'
            }
          }
        },
        legend: {
          data: ['访问量'],
          right: 0,
          icon: 'roundRect'
        },
        series: [
          {
            name: '访问量',
            data: obj.value,
            type: 'line',
            itemStyle: {
              normal: {
                color: '#2C9673'
              },
            },
          }
        ]
      };

      chart.setOption(opt)
      chart.hideLoading()
      window.addEventListener("resize", function () {
        chart.resize();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.tongji-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  .top-wrapper {
    flex-basis: 120px;
    flex-shrink: 0;
    .part {
      background: #ffffff;
      border-radius: 10px;
      padding: 20px;
      .count-wrapper {
        display: flex;
        justify-content: space-between;
        .left {
          margin-top: 15px;
          .count {
            font-size: 26px;
            font-weight: bold;
            color: #333333;
            line-height: 18px;
          }
          .subtitle {
            margin-top: 8px;
            font-size: 14px;
            font-weight: 400;
            color: #777777;
            line-height: 14px;
          }
        }

        .right {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          img {
            width: 100%;
            width: 100%;
          }
        }
      }

      .chart-wrapper {
        margin-top: 38px;
        width: 100%;
        height: 72px;
        .chart {
          width: 100%;
          height: 100%;
        }
        /deep/ .el-empty {
          padding: 0;
          .el-empty__image {
            display: none;
          }
        }
      }
    }
  }

  .middle-wrapper {
    background: #ffffff;
    padding: 0 20px;
    margin-top: 20px;
    box-sizing: border-box;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;

    .search-box {
      flex-basis: 84px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e6e6e6;
      .left {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        line-height: 38px;
      }
      .right {
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        line-height: 23px;
        .time {
          margin-right: 23px;
          &.active {
            color: $primary;
          }
        }
      }
    }

    .chart-box {
      padding-top: 20px;
      width: 100%;
      flex: 1;
      flex-shrink: 0;
      .chart {
        width: 100%;
        height: 100%;
      }
    }
  }

  .province-wrapper {
    margin-top: 18px;
    flex-basis: 280px;
    flex-shrink: 0;
    .province-inner {
      display: flex;
      flex-wrap: wrap;
      .province-part {
        flex-shrink: 0;
        box-sizing: border-box;
        width: calc((100% - 64px) / 5);
        height: 280px;
        background: #ffffff;
        margin-right: 16px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        &:nth-child(5n) {
          margin-right: 0;
        }
        p {
          margin-bottom: 12px;
          &.p1 {
            font-size: 26px;
            font-weight: bold;
            color: #333333;
            line-height: 26px;
          }

          &.p2 {
            font-size: 14px;
            font-weight: 400;
            color: #777777;
            line-height: 14px;
          }
        }
        .img-wrapper {
          height: 0;
          flex: 1;
          width: 100%;
          box-sizing: border-box;
          padding: 0 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>